/**
 * Type-safe client validator that ensures a client exists before use
 * @param client The client to validate
 * @param clientName The name of the client for error messaging
 * @throws {Error} If the client is undefined
 * @returns The validated client
 */
export function validateClient<T>(client: T | undefined, clientName: string): T {
  if (!client) {
    throw new Error(`${clientName} is not defined`);
  }
  return client;
}

/**
 * Type guard to check if a client exists
 * @param client The client to check
 * @returns True if the client exists, false otherwise
 */
export function hasClient<T>(client: T | undefined): client is T {
  return !!client;
}
